import React from 'react';
import {
  useSelector,
} from 'react-redux';
import CaretRightIcon from '../icons/caret-right';
import MeNowModal from '../me-now-modal';
import { UnreachableError } from 'hellospa/ts-utils';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { useIntl } from 'react-intl';

import styles from '../index.scss';
import messages from '../intl';

type MeOnlyProps = {
  recipients: types.Recipient[],
  onMeOnly: () => unknown
}
const MeOnlyBtn = ({ onMeOnly, recipients }: MeOnlyProps) => {
  const intl = useIntl();
  const workflow = useSelector(selectors.getWorkflow);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const allowMeOnlyAsSigner = useSelector(selectors.allowMeOnlyAsSigner);
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);

  if (!workflow.tags.includes(types.WorkflowTags.SignatureRequestDocument)) {
    return null;
  }

  const saveMeOnly = async () => {
    onMeOnly();
  };

  const handleMeOnly = async () => {
    const filteredRecipients = recipients.filter((r) => {
      switch (r.type) {
        case types.RecipientTypes.Signer: {
          // Filter out empty signers
          return r.name !== '' && r.email !== '';
        }
        case types.RecipientTypes.Role:
        case types.RecipientTypes.Fax:
          // These types aren't really relevant in a flow that could be me-only,
          // but they still need to be handled.
          return true;
        default: throw new UnreachableError(r);
      }
    });

    if (filteredRecipients.length === 0) {
      await saveMeOnly();
    } else {
      setModalOpen(true);
    }
  };

  if (!allowMeOnlyAsSigner) {
    return null;
  }

  return (
    <div className={styles.meOnlyButtonContainer}>
      <MeNowModal
        isOpen={isModalOpen}
        onConfirm={saveMeOnly}
        onCancel={() => setModalOpen(false)}
        confirmButtonType={isDeepIntegration ? ButtonType.Primary : undefined} />
      <Button
        type="button"
        kind={ButtonType.Subtle}
        className={styles.meOnlyButton}
        onClick={handleMeOnly}
        data-qa-ref="recipients.buttons.me_now"
      >
        {intl.formatMessage(messages.meNowSignerButton)}
        <CaretRightIcon className={styles.caretRightIcon} />
      </Button>
    </div>
  );
};


export default MeOnlyBtn;
